/**
 * @param {string} searchValue
 * @param {string} replaceValue
 * @param {*} haystack
 * @returns {any}
 */
function deepReplace (searchValue, replaceValue = '', haystack) {
  if (!searchValue || !haystack) return haystack

  const regex = new RegExp(searchValue, 'g')
  return JSON.parse(JSON.stringify(haystack)
    .replace(regex, replaceValue))
}

module.exports = { deepReplace }
